import { z } from 'zod';

/**
 * The health contract.
 *
 * This is a real shared schema rather than a stub: `apps/server` answers it and
 * `apps/web` renders it, so the §3.D condition — both apps importing a type
 * that originates from one schema file — is satisfied by something the skeleton
 * actually uses. The Phase 1 object model (workspace, board, list, card,
 * comment, label, membership, notification) is deliberately absent; that is
 * feature work and belongs to whoever builds those features.
 */

export const dependencyStatusSchema = z.object({
  ok: z.boolean(),
  /** Round-trip in milliseconds, absent when the check failed outright. */
  latencyMs: z.number().nonnegative().optional(),
  /** Present only when `ok` is false. Never contains credentials. */
  error: z.string().optional(),
});

export type DependencyStatus = z.infer<typeof dependencyStatusSchema>;

export const healthSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  service: z.string(),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
  checks: z.object({
    database: dependencyStatusSchema,
    redis: dependencyStatusSchema,
  }),
});

export type Health = z.infer<typeof healthSchema>;
